import React from 'react';
import moment from 'moment';

const EventWrapper = ({ hourStart }) => ({ event, children }) => {
	const { title, className } = children.props;
	const customClass = `${className}`;
	const minuteStart = (moment(event.start).hour() - hourStart) * 60 + moment(event.start).minute();
	const minuteStop = (moment(event.end).hour() - hourStart) * 60 + moment(event.end).minute();
	const gridRowStart = minuteStart + 1;

	return (
		<div
			title={title}
			className={customClass}
			style={{ gridRow: `${gridRowStart} / span ${minuteStop - minuteStart}` }}
			onClick={children.props.onClick}
		>
			{children.props.children}
		</div>
	);
};

export default EventWrapper;
